import { IApiLocation } from "src/utilities/interfaces/locations.api.interface";

/**
 * Lista de tipos de localizaciones
 */
export enum LocationsTypes {
    Group = 10, // Grupo
    Company = 20, // Empresa
    Client = 30, // Cliente
    Center = 40, // Centro
    Area = 50, // Área
}


/**
 * Helper con utilidades para entidades de localización
 */
export class LocationsHelper {
    /**
     * Devuelve el título de la ventana de localización
     * @param type Tipo de localización
     * @param isEdit Si es edición
     * @returns Título internacionalizado
     */
    public static GetTitle(type: number, isEdit: boolean): string {
        switch (type) {
            case LocationsTypes.Company:
                return isEdit ? '$locations.edit.titleEditCompany' : '$locations.add.titleAddCompany';
            case LocationsTypes.Client:
                return isEdit ? '$locations.edit.titleEditClient' : '$locations.add.titleAddClient';
            case LocationsTypes.Center:
                return isEdit ? '$locations.edit.titleEditCenter' : '$locations.add.titleAddCenter';
            }
        return '';
    }

    /**
     * Devuelve la cadena "Empresa - Centro - Zona" a partir de una zona
     * @param zone Zona a analizar
     */
    public static GetCompanyCenterZoneByZone(zone: IApiLocation): string {
        if (zone) {
            const company = zone.LoM_Locations?.LoM_Locations?.name ?? '';
            const center = zone.LoM_Locations?.name ?? '';
            const zoneName = zone.name;
            return `${company} - ${center} - ${zoneName}`;
        }
        return '';
    }
}

